import { Components, Theme } from '@mui/material';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.featureFlags.panwRebrandStubYear
        ? theme.palette.interactive.highlight.default
        : theme.palette.primary.main,
      color: theme.featureFlags.panwRebrandStubYear
        ? theme.palette.text.inversePrimary
        : theme.palette.primary.contrastText,
    }),
  },
};
